import { createSlice } from "@reduxjs/toolkit"

const campaignSlice = createSlice({
   name: "campaigns",
   initialState: {
      campaigns: null,
      getCampaignsLoading: false,
      createCampaignLoading: false
   },
   reducers: {
      getCampaignsLoading: (state) => {
         state.getCampaignsLoading = true
      },
      getCampaignsSuccess: (state, action) => {
         state.campaigns = action.payload
         state.getCampaignsLoading = false
      },
      getCampaignsFailure: (state) => {
         state.getCampaignsLoading = false
      },
      createCampaignLoading: (state) => {
         state.createCampaignLoading = true
      },
      createCampaignSuccess: (state, action) => {
         // state.campaigns = [...state.campaigns, action.payload]
         state.createCampaignLoading = false
      },
      createCampaignFailure: (state) => {
         state.createCampaignLoading = false
      }
   }
})

export const {
   getCampaignsLoading,
   getCampaignsSuccess,
   getCampaignsFailure,
   createCampaignLoading,
   createCampaignSuccess,
   createCampaignFailure
} = campaignSlice.actions

export default campaignSlice.reducer 